import React, { useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import FilterNavbar from "../Saved Address/Components/Search Bar/FilterNavbar";
import CustomAccordion from "../CustomAccordion";
import HeadphonesIcon from "@mui/icons-material/Headphones";
import EastIcon from "@mui/icons-material/East";
import Button from "@mui/material/Button";
// import { Link } from "react-router-dom";
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
// import Divider from "@mui/material/Divider";
// import ListItem from "@mui/material/ListItem";
// import ListItemButton from "@mui/material/ListItemButton";
// import ListItemIcon from "@mui/material/ListItemIcon";
// import ListItemText from "@mui/material/ListItemText";
// import InboxIcon from "@mui/icons-material/MoveToInbox";
// import MailIcon from "@mui/icons-material/Mail";
import CloseIcon from "@mui/icons-material/Close";
// import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
// import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import MealTag from "../CustomerSupport/MealTag";
import { styled, useTheme } from "@mui/material/styles";
import IconButton from "@mui/material/IconButton";
import CustomTextInputField from "../CustomTextInputField";
import io from 'socket.io-client';
import { getIdTokenResult } from "firebase/auth";
import { useGetAllMessagesQuery } from "api/messages";

const socket = io('http://localhost:4000'); // Replace with your server address
// const socket = io('http://localhost:5000'); // Replace with your server address
// const socket = io("https://ec-backend.vercel.app/api")
// const socket = io("https://ec-backend-deployed.vercel.app/api")



const accordionData = [
  {
    id: "1",
    title: "Help with an order",
    desp: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s",
    children: [
      {
        id: "1",
        title: "Past order",
        desp: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s",
      },
      {
        id: "2",
        title: "Savety issue",
        desp: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s",
      },
    ],
  },
  {
    id: "2",
    title: "Account & Payment Option",
    desp: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s",
  },
  {
    id: "3",
    title: "How to delivery & picked up",
    desp: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s",
  },
  {
    id: "4",
    title: "Pass information",
    desp: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s",
  },
];

const quickMessagesArr = [
  "Wrong or missing items",
  "Food damage or quality issue",
  "Clarify my total order",
  "I have a safety issues",
];


const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
}));

const QuickMessagesHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
  justifyContent: "space-between",
  padding: "10px",
  margin: "0px 10px",
}));

const QuickMessagesWrapper = styled("div")(({ theme }) => ({
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
  border: "1px solid #E1E1E6",
  borderRadius: "4px",
  padding: "10px",
  margin: "0px 20px",
}));

const GetHelp = () => {
  const [state, setState] = React.useState({
    right: false,
  });

  const [showQuickmsg, setshowQuickmsg] = useState(true)

  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setState({ ...state, [anchor]: open });
  };

  const list = (anchor) => (
    <Box
      sx={{
        width:
          anchor === "top" || anchor === "bottom"
            ? "auto"
            : { lg: "511.13px", md: "511.13px", sm: "auto", xs: "auto" },
      }}
      role="presentation"
    >
      <List>
        <MealTag />
      </List>
    </Box>
  );

  const { data: getAllMessages, isLoading, refetch: getAllMessagesRefetch } = useGetAllMessagesQuery(); // Destructure as an object
  const [message, setMessage] = useState('');
  const [messages, setMessages] = useState([]);
  const token = JSON.parse(localStorage.getItem("token"))
  const user = JSON.parse(localStorage.getItem("user"))

  const getMessges = () => {
    // if (getAllMessages) { // Ensure getAllMessages is not null or undefined
    console.log("messages", getAllMessages);
    const filterMsg = getAllMessages?.data?.filter((msg) => msg?.roomId === user?.profile?._id)
    console.log("filterMsg", filterMsg)
    setMessages(filterMsg); // Assuming getAllMessages contains messages
    // }
  }


  useEffect(() => {
    console.log("component rdner")
    // socket.emit('customer', user?.profile?._id);
    socket.emit('join', token);
    // socket.emit('join room', user?.profile?._id);
    getMessges()
  }, [getAllMessages?.data, message]);

  const sendMessage = () => {
    console.log(message)
    // socket.emit('join', token);
    socket.emit('message', { message: message, id: user?.profile?._id, type: "user" });
    // socket.emit('chat message',  message,  user?.profile?._id );
    getAllMessagesRefetch()
    setMessage('');
  };


  return (
    <>
      <Box>
        <Box>
          <FilterNavbar />
        </Box>

        <Box borderBottom="1px solid #e1e1e6" py="10px">
          <Box
            sx={{
              width: { xs: "100%", md: "95%" },
              margin: { xs: "0px", md: "0px auto" },
            }}
            p="5px"
            pt="20px"
          >
            <Typography fontSize="24px" fontWeight="600">
              Get Help
            </Typography>
          </Box>
        </Box>

        <Box borderBottom="1.5px solid #e1e1e6" py="10px">
          <Box
            sx={{
              width: { xs: "100%", md: "95%" },
              margin: { xs: "0px", md: "0px auto" },
            }}
            p="5px"
          >
            <Grid container gap={1} justifyContent="center">
              <Grid
                item
                xs={12}
                md={4.8}
                borderRight="1.5px solid #e1e1e6"
                minHeight="400px"
              >
                <Typography fontSize="24px" fontWeight="600" my="5px" mb="15px">
                  Your Order
                </Typography>
                <Box width="100%" p="5px">
                  <Box
                    display="flex"
                    flexWrap="wrap"
                    justifyContent="flex-start"
                    alignItems="center"
                  >
                    <Box width="144px">
                      <img
                        src="images/qouftadishpic.png"
                        alt="qouftadishpic"
                        width="100%"
                      />
                    </Box>
                    <Box minWidth="252px" ml="10px" p="10px">
                      <Typography fontSize="20px" fontWeight="600">
                        Baked Fish Fillets with...
                      </Typography>
                      <Box>
                        <img
                          src="images/iMacMemojiCircle.svg"
                          alt="iMacMemojiCircle"
                        />
                        <Typography
                          component="span"
                          fontSize="14px"
                          fontWeight="400"
                          color="#9EA3AE"
                          ml="7px"
                          sx={{ verticalAlign: "text-bottom" }}
                        >
                          Chef Juna Food, 4474 Bridge
                        </Typography>
                      </Box>
                      <Box mt="40px">
                        <img src="images/calendarIcon.svg" alt="calendarIcon" />
                        <Typography
                          component="span"
                          fontSize="14px"
                          fontWeight="400"
                          color="#9EA3AE"
                          ml="7px"
                          sx={{ verticalAlign: "text-bottom" }}
                        >
                          12 Oct -12 Nov 2021
                        </Typography>
                      </Box>
                    </Box>
                  </Box>
                  <Button
                    sx={{
                      marginLeft: "auto",
                      borderRadius: "6px",
                      fontSize: "16px",
                      fontWeight: "600",
                      textTransform: "capitalize",
                      p: "7px 20px 7px 20px",
                      mt: "15px",
                    }}
                    variant="outlined"
                  >
                    Change
                  </Button>
                </Box>

                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  borderRadius="4px"
                  bgcolor="#F0FAF9"
                  p="20px"
                  mt="50px"
                  mx="5px"
                  sx={{ cursor: "pointer" }}
                  onClick={toggleDrawer("right", true)}
                >
                  <Box
                    display="flex"
                    justifyContent="flex-start"
                    alignItems="center"
                    p="10px"
                  >
                    <Box
                      alignSelf="flex-start"
                      mt="10px"
                      bgcolor="white"
                      borderRadius="50%"
                      p="10px 15px"
                    >
                      <HeadphonesIcon
                        sx={{ color: "#2B817B", fontSize: "32px" }}
                      />
                    </Box>
                    <Box ml="20px">
                      <Typography
                        fontSize="20px"
                        fontWeight="600"
                        my="5px"
                        color="black"
                      >
                        Customer Support
                      </Typography>
                      <Typography
                        fontSize="16px"
                        fontWeight="400"
                        color="#545359"
                        my="5px"
                      >
                        Chat message service with our customer support
                      </Typography>
                    </Box>
                  </Box>
                  <Box p="10px">
                    <EastIcon sx={{ color: "#2B817B" }} />
                  </Box>
                </Box>
              </Grid>
              <Grid item xs={12} md={7} p="15px ">
                <Typography fontSize="24px" fontWeight="600" my="5px" mb="15px">
                  FAQ
                </Typography>
                <CustomAccordion data={accordionData} />
              </Grid>
            </Grid>
          </Box>
        </Box>
        <Drawer
          anchor={"right"}
          open={state["right"]}
          onClose={toggleDrawer("right", false)}
        >
          <DrawerHeader>
            <IconButton onClick={toggleDrawer("right", false)}>
              <CloseIcon sx={{ color: "#E75C62" }} />
            </IconButton>
            <Typography fontSize="20px" fontWeight="600" mx="auto">
              Customer Support
            </Typography>
          </DrawerHeader>
          {list("right")}
          <Box mt="20px" mb="10px"
            sx={{ overflowY: "scroll", minHeight: "50vh" }} >
            <Box textAlign="center">
              <Typography fontSize="14px" fontWeight="400" color="#9EA3AE">
                Today
              </Typography>
            </Box>
            <Box
              display="flex"
              flexDirection={"column"}
              // alignItems="flex-end"
              p="10px"
              my="15px"
              mx="10px"

            >
              {messages?.length > 0 && messages?.map((msg) => (
                <Box my={1} display={"flex"} justifyContent={!msg.fromAdmin ? "right" : "left"}>
                  {/* <Box width="40px" height="40px">
                    <img
                      src="images/eatCostEIcon.svg"
                      alt="customerCareUserIcon"
                      width="100%"
                      height="100%"
                    />
                  </Box> */}
                  <Box
                    p="16px"
                    bgcolor={"#2B817B"}
                    // bgcolor={msg.type === "user" ? "#fff" : "#2B817B"}
                    ml="10px"
                    maxWidth="240px"
                    borderRadius="8px 8px 8px 0px"
                    wordWrap="break-word"
                  // border="1px solid red"
                  >
                    <Typography fontSize="14px" fontWeight="400" color={msg.fromAdmin ? "#fff" : "#000"} sx={{ wordWrap: "break-word" }}>
                      {msg.message}
                    </Typography>
                  </Box>
                </Box>

              ))

              }
            </Box>
          </Box>
          {showQuickmsg && (<Box mt="10px" mb="20px">
            <QuickMessagesHeader>
              <Typography fontSize="20px" fontWeight="600">
                Quick messages
              </Typography>
              <IconButton onClick={() => setshowQuickmsg(false)}>
                <CloseIcon sx={{ color: "#E75C62" }} />
              </IconButton>
            </QuickMessagesHeader>
            <QuickMessagesWrapper>
              {quickMessagesArr && showQuickmsg &&
                quickMessagesArr.map((item, index) => (
                  <Typography
                    fontSize="14px"
                    fontWeight="400"
                    p="12px 5px"
                    my="5px"
                    borderBottom="1px solid #e1e1e6"
                    onClick={() => setMessage(item)}
                  >
                    {item}
                  </Typography>
                ))}
            </QuickMessagesWrapper>
          </Box>)}

          <Box mt="10px" mb="20px" mx="20px">
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
            >
              <Box flexGrow={1}>
                <CustomTextInputField
                  // name='username'
                  value={message}
                  // isPasswordField={true}
                  placeholder="Type message ..."
                  fullWidth
                  onChangeHandler={(e) => setMessage(e.target.value)}
                // lableFontSize="18px"
                // lableFontWeight="500"
                />
              </Box>
              <Box width="42px" height="42px" ml="20px">
                <img
                  src="images/sendMessageButton.svg"
                  width="100%"
                  height="100%"
                  onClick={sendMessage}
                />
              </Box>
            </Box>
          </Box>
        </Drawer>
      </Box >
    </>
  );
};

export default GetHelp;
